// extracted by mini-css-extract-plugin
export default {"root":"LotteryActions_root__4yRg5"};